// Entry point for CM6 bundle — exports everything to window._CM6

import {EditorView, keymap, lineNumbers, highlightActiveLine, highlightActiveLineGutter,
        highlightSpecialChars, drawSelection, dropCursor, placeholder} from "@codemirror/view";
import {EditorState, Compartment} from "@codemirror/state";
import {syntaxHighlighting, indentOnInput, bracketMatching, foldGutter, foldKeymap,
        indentUnit, HighlightStyle} from "@codemirror/language";
import {defaultKeymap, history, historyKeymap, indentWithTab} from "@codemirror/commands";
import {searchKeymap, highlightSelectionMatches} from "@codemirror/search";
import {autocompletion, closeBrackets, closeBracketsKeymap, completionKeymap} from "@codemirror/autocomplete";
import {lintKeymap, lintGutter, linter} from "@codemirror/lint";
import {python} from "@codemirror/lang-python";
import {json} from "@codemirror/lang-json";
import {tags} from "@lezer/highlight";

window._CM6 = {
    EditorView, keymap, lineNumbers, highlightActiveLine, highlightActiveLineGutter,
    highlightSpecialChars, drawSelection, dropCursor, placeholder,
    EditorState, Compartment,
    syntaxHighlighting, indentOnInput, bracketMatching, foldGutter, foldKeymap,
    indentUnit, HighlightStyle,
    defaultKeymap, history, historyKeymap, indentWithTab,
    searchKeymap, highlightSelectionMatches,
    autocompletion, closeBrackets, closeBracketsKeymap, completionKeymap,
    lintKeymap, lintGutter, linter,
    python, json, tags
};

window.dispatchEvent(new Event('cm6-ready'));
console.log('✓ CodeMirror 6 bundle carregat');
